import { mdiAccountCircle } from '@mdi/js'
import { useIntl } from 'react-intl'

import { teamPageMessages } from 'features/team/messages'
import { StyledUserAvatar, StyledUserDefaultAvatar } from './styles'

interface AvatarBlockProps {
  url?: string
}

function AvatarBlock({ url }: AvatarBlockProps) {
  const { formatMessage } = useIntl()

  return url ? (
    <StyledUserAvatar
      url={url}
      alt={formatMessage(teamPageMessages.avatarImageAlt)}
    />
  ) : (
    <StyledUserDefaultAvatar path={mdiAccountCircle} />
  )
}

export default AvatarBlock
